import { useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import LoggedOut from './pages/logged-out/logged-out'
import NotFound from './pages/not-found/not-found'
import Chat from './pages/chat/chat'
import Login from './pages/login/login'
import Settings from './pages/settings/settings'
import StaticPage from './pages/static-page/static-page'
import { CookieNotice } from './components/cookie-notice'
import DevModeBanner from './components/dev-mode-banner'
import OnboardingBanner from './components/onboarding-banner'
import { SessionProvider, useSessionContext } from './state/session-context'
import { useNotificationLifecycle } from './state/use-notification-lifecycle'
import { useAppUpdateCheck } from './state/app-update'

function AppContent() {
	const { session } = useSessionContext()
	useNotificationLifecycle(session?.userId)
	useAppUpdateCheck()
	const [notificationChangeCounter, setNotificationChangeCounter] = useState(0)
	const triggerNotificationSync = () => setNotificationChangeCounter(c => c + 1)
	return (
		<div
			className="h-screen flex flex-col font-main"
			style={{
				paddingBottom: 'env(safe-area-inset-bottom)'
			}}
		>
			<DevModeBanner />
			<OnboardingBanner notificationChangeCounter={notificationChangeCounter} />
			<div className="flex-1 min-h-0">
				<Routes>
					<Route path="/" element={<LoggedOut />} />
					<Route path="/faq" element={<StaticPage kind="faq" />} />
					<Route path="/terms" element={<StaticPage kind="terms" />} />
					<Route path="/privacy" element={<StaticPage kind="privacy" />} />
					<Route path="/login" element={<Login />} />
					<Route path="/chat/:channelId?" element={<Chat />} />
					<Route path="/settings" element={<Settings onNotificationChange={triggerNotificationSync} />} />
					<Route path="*" element={<NotFound />} />
				</Routes>
			</div>

			<CookieNotice />
		</div>
	)
}

function App() {
	return (
		<SessionProvider>
			<AppContent />
		</SessionProvider>
	)
}

export default App
